module.exports = __webpack_public_path__ + "static/media/logo-tweakers--squared.e94a5798.png";